import React, { useMemo } from 'react';

import Image from '../../components/Image/Image';
import Currency from '../../../helpers/currency';
import { ExternalLink, InternalLink } from '../../components/form-elements/Link';
import WiderrufModal from '../../components/Widerruf/WiderrufModal';
import Button from '../../components/form-elements/Button';

const OrderContentProduct = props => {
    const { images, currentOrderState, orderStatusLabel, orderId, product = {}, markenStandort, showWiderrufButton, widerrufInitialValues } = props;

    const shoppingLink = useMemo(() => {
        if (!!product?.categories?.[0]) {
            return `/${product?.categories?.[0]}/${product.id || product._id}`;
        } else if (!!product?.category) {
            return `/${product?.category}/${product.id || product._id}`;
        }
        return '';
    }, [product]);

    const trackingLinks = useMemo(() => {
        if (Array.isArray(product.trackingLinks) && product.trackingLinks.length) {
            return product.trackingLinks.filter(Boolean);
        }
        if (product.trackingLink) {
            return [product.trackingLink];
        }
        return [];
    }, [product]);

    const productName = useMemo(() => {
        const rawName = product.bezeichnung || product.serviceTitle || 'Artikel';
        return String(rawName).replace(/<[^>]*>/g, '').trim() || 'Artikel';
    }, [product]);

    const getTrackingLinkAriaLabel = index => {
        if (trackingLinks.length > 1) {
            return `Sendung verfolgen ${index + 1} - ${productName}`;
        }
        return `Sendung verfolgen - ${productName}`;
    };

    const showShoppingLink = !!shoppingLink;
    const showTrackingLink = trackingLinks.length > 0;

    return (
        <div className="uk-child-width-1-1" data-uk-grid="">
            <div>
                <div data-uk-grid="">
                    <div className="uk-width-1-1 uk-width-1-6@s">
                        <div className="uk-flex uk-flex-center">
                            <Image src={images[0]} alt="Produktbild" style={{ maxHeight: 200 }} resizeHeight={200} />
                        </div>
                    </div>
                    <div className="uk-width-expand">
                        <h2>
                            <span dangerouslySetInnerHTML={{ __html: product.bezeichnung }} /> {product.serviceTitle}
                        </h2>
                        <div>Artikelnummer: {product.shownId || product.id}</div>
                        {product.orderStatus && (
                            <div>
                                Status: <span className="uk-text-primary">{orderStatusLabel ?? '---'}</span>
                            </div>
                        )}
                        {markenStandort && (
                            <div>
                                Autohaus: <span className="uk-text-primary">{markenStandort.anschrift.firma}</span>,{' '}
                                {markenStandort.anschrift.strasse} {markenStandort.anschrift.plz} {markenStandort.anschrift.ort}
                            </div>
                        )}
                    </div>
                    <div className="uk-width-1-1 uk-width-auto@s uk-flex uk-flex-right">
                        <table className="uk-table uk-table-small">
                            <thead>
                                <tr>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Menge</th>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Einzelpreis</th>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Summe</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="uk-text-right">
                                    <td>{product.quantity}</td>
                                    <td>
                                        <Currency quantity={product.vk_preis} />
                                    </td>
                                    <td className="uk-text-bold">
                                        <Currency quantity={product.vk_preis * product.quantity} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {(showShoppingLink || showTrackingLink || showWiderrufButton) && (
                <div>
                    {showShoppingLink && (
                        <InternalLink modifier="primary" to={shoppingLink}>
                            Erneut kaufen
                        </InternalLink>
                    )}{' '}
                    {showTrackingLink &&
                        trackingLinks.map((link, index) => (
                            <span key={`${link}-${index}`}>
                                {index > 0 ? ' ' : ''}
                                <ExternalLink modifier="primary" to={link} ariaLabel={getTrackingLinkAriaLabel(index)}>
                                    Sendung verfolgen
                                </ExternalLink>
                            </span>
                        ))}{' '}
                    {showWiderrufButton && (
                        <WiderrufModal initialValues={widerrufInitialValues} variant="account">
                            {({ openModal }) => (
                                <Button modifier="primary" onClick={openModal} ariaHasPopup="dialog">
                                    Vertrag widerrufen
                                </Button>
                            )}
                        </WiderrufModal>
                    )}
                </div>
            )}
        </div>
    );
};

export default OrderContentProduct;
